import React, { useState } from 'react';
import Badge from '../ui/Badge';
import Button from '../ui/Button';
import Icons from '../Icons';
import { formatDateTime, parseAttendanceDescription } from './timelineUtils';

export default function AttendanceCluster({ cluster }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div
      className="sp-panel sp-event-card sp-event-card--muted p-4"
      aria-label="Attendance cluster"
      style={{ borderLeft: '4px solid var(--sp-border)' }}
    >
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-start gap-3">
          <div aria-hidden="true" className="mt-1 text-slate-600">
            <Icons.Calendar />
          </div>
          <div>
            <div className="sp-event-kicker">Attendance cluster</div>
            <h4 className="sp-event-title">
              Attended sessions - {cluster.programme || 'General'} x {cluster.count}
            </h4>
            <p className="text-sm sp-muted mt-2">Grouped low-risk attendance entries.</p>
            <div className="sp-event-tags">
              <Badge variant="inactive">Low priority</Badge>
            </div>
            <div className="sp-event-meta">
              <span>
                <span className="sp-meta-label">Programme</span>
                <span>{cluster.programme || 'General'}</span>
              </span>
              <span>
                <span className="sp-meta-label">Count</span>
                <span>{cluster.count}</span>
              </span>
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Button
            size="sm"
            variant="ghost"
            type="button"
            onClick={() => setExpanded((prev) => !prev)}
            aria-expanded={expanded}
            aria-controls={`cluster-${cluster.id}`}
          >
            {expanded ? 'Hide' : 'Expand'}
          </Button>
        </div>
      </div>
      {expanded && (
        <div id={`cluster-${cluster.id}`} className="sp-event-details" role="region">
          {cluster.items.map((item) => {
            const meta = parseAttendanceDescription(item.description);
            return (
              <div key={item.id} className="sp-event-details__item">
                <span>
                  {formatDateTime(item.date)} · {meta.status || 'attended'}
                </span>
                {meta.notes && <span>{meta.notes}</span>}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
